import { FlattenSimpleInterpolation, css } from 'styled-components'
import { ThemeType } from 'theme'

export const getContainerCss = ({
  theme,
  primary
}: {
  theme: ThemeType
  primary?: string
}): FlattenSimpleInterpolation => {
  if (primary) {
    return css`
      background: ${primary};
    `
  }
  return css`
    background-image: linear-gradient(
      294deg,
      ${theme.modal.backgroundStart} 30%,
      ${theme.modal.backgroundEnd} 70%
    );
  `
}
